import React, { useEffect, useState } from 'react'
import {
  CButton,
  CForm,
  CFormCheck,
  CFormInput,
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
} from '@coreui/react-pro'
import { CashBooster } from '../../list/types'
import { format } from 'date-fns'
import {
  $isSuccessCreate,
  createBlockPartnerMounted,
  closeModal,
  updateBlockPartnerMounted,
  $isSuccessUpdate,
} from './model'
import { useUnit } from 'effector-react'

type Props = {
  isVisible: boolean
  onClose: () => void
  data: CashBooster
}

export const BlockingModal: React.FC<Props> = ({
  isVisible,
  onClose,
  data,
}) => {
  const [blocked, setBlocked] = useState(data.isBlocked)
  const [tillDate, setTillDate] = useState(
    data.blockedToDate && data.isBlocked
      ? data.blockedToDate.split('T')[0]
      : '',
  )
  const [validated, setValidated] = useState(false)

  const [isSuccessCreate, modalCloseFn] = useUnit([
    $isSuccessCreate,
    closeModal,
  ])

  const [isSuccessUpdate, modalClose] = useUnit([$isSuccessUpdate, closeModal])

  useEffect(() => {
    if (isSuccessCreate) {
      modalCloseFn()
      onClose()
    }
    if (isSuccessUpdate) {
      modalClose()
      onClose()
    }
  }, [isSuccessCreate, isSuccessUpdate])

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const form = event.currentTarget

    if (form.checkValidity() === false) {
      event.preventDefault()
      event.stopPropagation()
    } else {
      event.preventDefault()
      if (data.blockId === 0) {
        const today = new Date()
        createBlockPartnerMounted({
          id: data.clientId,
          blockedFromDate: today.toISOString().split('T')[0],
          blockedToDate: tillDate,
        })
      } else {
        updateBlockPartnerMounted({
          id: data.blockId,
          blockedFromDate: data.blockedFromDate,
          blockedToDate: tillDate,
          isDeleted: !blocked,
        })
      }
    }

    setValidated(true)
  }

  const handleBlockedChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setBlocked(e.target.checked)
  }

  const handleDateChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const date = e.target.value
    setTillDate(date)
  }

  // Получаем текущую дату в формате YYYY-MM-DD
  const getCurrentDate = () => {
    return format(new Date(), 'yyyy-MM-dd')
  }

  return (
    <CModal visible={isVisible} onClose={onClose}>
      <CModalHeader>
        <CModalTitle>
          {data.isBlocked ? 'Update partner block' : 'Create partner block'}
        </CModalTitle>
      </CModalHeader>
      <CModalBody>
        <div className="mb-3">
          <strong>Partner ID:</strong> {data.clientId}
        </div>
        <div className="mb-3">
          <strong>Full Name:</strong> {data.fullName}
        </div>

        <CForm noValidate validated={validated} onSubmit={handleSubmit}>
          {data.blockId !== 0 && (
            <CFormCheck
              id="blockedCheckbox"
              label="Blocked"
              checked={blocked}
              onChange={handleBlockedChange}
              className="mb-3"
            />
          )}

          {/*{blocked && (*/}
          <div className="mb-3">
            <CFormInput
              type="date"
              id="tillDate"
              label="Till date (To ban a user permanently, leave field empty.)"
              value={tillDate}
              min={getCurrentDate()}
              onChange={handleDateChange}
            />
          </div>
          {/*)}*/}
          <div className="d-flex justify-content-end gap-2">
            <CButton color="secondary" onClick={onClose}>
              Cancel
            </CButton>
            <CButton color="primary" type="submit">
              Save
            </CButton>
          </div>
        </CForm>
      </CModalBody>
    </CModal>
  )
}
